import { useCallback } from 'react';
import { useMutation } from 'src/graphql';
import { REOPEN_CAP_MUTATION } from 'src/graphql/job/mutation';

const useReopenCap = () => {
  const [reopenCap] = useMutation(REOPEN_CAP_MUTATION);

  return useCallback(
    ({ jobId }) =>
        reopenCap({
        variables: {
          jobId
        },
      }),
    [],
  );
};
export default useReopenCap;
